import { Component, EventEmitter, inject, Input, OnInit, Optional, Output } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { AutoComplete } from 'primeng/autocomplete'

import { PartnersApi } from '@app/apis/partners.api'
import { PagedResponse } from '@app/components/generic/generic'
import { DetailMode } from '@app/components/generic/generic.constants'
import type { Partner } from '@app/generated/api/model'

@Component({
  selector: 'app-partner-field',
  templateUrl: 'partner-field.component.html',
  // styleUrl: 'supplier-field.component.less',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    AutoComplete,
    FormsModule,
  ],
})
export class PartnerFieldComponent implements OnInit {
  public readonly partnersApi = inject(PartnersApi)

  @Input() partner?: Partner
  @Input() required: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() partnerChange = new EventEmitter<Partner | undefined>()

  public allPartners: Partner[] = []
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    this.allPartners = []
    if (this.partner) {
      this.allPartners = [this.partner]
    }
  }

  /**
   * Return partners matching the given code using an `icontains` matcher.
   * This is necessary because we cannot present a list of *all* partners: it must be pre-filtered.
  */
  getPartnerSuggestions ($event: { query: string, originalEvent: any }) {
    this.partnersApi.list({ limit: 1000, ordering: 'name', name: $event.query }).subscribe(
      (res: PagedResponse<Partner>) => {
        this.allPartners = res.results
      })
  }
}
